import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
          if (localStorage.getItem('currentUser')) {
              return true;
          }

          this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
          return false;
      }


}


@Injectable()
export class AuthGuardDeva implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
          if (localStorage.getItem('currentUser')) {
            const currentUser = JSON.parse(localStorage.getItem('currentUser'));
            const rol = currentUser.rol;
                if (rol==1 || rol==2) {
                    return true;
                }
        }
              this.router.navigate(['/login']);
              return false;
          }
    


}



@Injectable()
export class AuthGuardUniv implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
          if (localStorage.getItem('currentUser')) {
            const currentUser = JSON.parse(localStorage.getItem('currentUser'));
            const rol = currentUser.rol;
                if (rol==3) {
                    return true;
                }
        }
              this.router.navigate(['/universidad']);
              return false;
          }
    


}


// WEBPACK FOOTER //
// /app/src/app/auth.guard.ts